var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-dark",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('back')}}},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.label))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }